// ======================================================================
// File: TransportBookingCard.jsx
// Module: PPE → Transport
// Purpose:
//   Booking section — Assign Transporter
//   ERP Lifecycle: REQUESTED → BOOKED
// ======================================================================

import React, { useState } from "react";
import transportService from "../../services/transportService";

export default function TransportBookingCard({
  transport,
  reload,
}) {

  const [search, setSearch] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // ------------------------------------------------------------------
  // SEARCH TRANSPORTERS
  // ------------------------------------------------------------------
  const searchTransporters = async (value) => {
    setSearch(value);

    if (!value || value.length < 2) {
      setOptions([]);
      return;
    }

    try {
      const res = await transportService.searchTransporters(value);
      setOptions(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // ------------------------------------------------------------------
  // ASSIGN TRANSPORTER (BOOKING)
  // ------------------------------------------------------------------
  const assignTransporter = async (transporterId) => {
    try {
      setLoading(true);

      await transportService.assignTransporter(
        transport.id,
        transporterId
      );

      await reload();

    } catch (err) {
      console.error(err);
      alert("Failed to assign transporter");
    } finally {
      setLoading(false);
      setOptions([]);
      setSearch("");
    }
  };

  // ------------------------------------------------------------------
  // HIDE IF ALREADY BOOKED
  // ------------------------------------------------------------------
 // Hide only if transporter already assigned
if (transport.transporter_bp_id) {
  return null;
}


  // ------------------------------------------------------------------
  // UI
  // ------------------------------------------------------------------
  return (
    <div className="card glass-card mb-3">
      <div className="card-body">

        <h6 className="mb-3">
          🚚 Transport Booking
        </h6>

        <div className="position-relative">

          <input
            className="form-control"
            placeholder="Search transporter..."
            value={search}
            onChange={(e) =>
              searchTransporters(e.target.value)
            }
          />

          {options.length > 0 && (
            <div className="lookup-dropdown">
              {options.map((t) => (
                <div
                  key={t.id}
                  className="lookup-item"
                  onClick={() => assignTransporter(t.id)}
                >
                  {t.name}
                </div>
              ))}
            </div>
          )}

        </div>

        {loading && (
          <div className="mt-2 small text-muted">
            Assigning transporter...
          </div>
        )}

      </div>
    </div>
  );
}
